import { useCallback, useState } from "react";
import axios from "axios";
import config from "../../../config";

const EMPTY_CHARTS = { data: [] };

const useJunctionChartData = () => {
  const [chartsData, setChartsData] = useState(EMPTY_CHARTS);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchChartData = useCallback(({ junctionId, metric, from, to }) => {
    setLoading(true);
    setError(null);
    return axios
      .get(`${config.FLYOVER_RCM_API_URL}/approach/data/chart`, {
        headers: { "X-API-Key": config.FLYOVER_RCM_API_TOKEN },
        params: { junctionId, metric, from, to },
      })
      .then((res) => {
        setChartsData({ data: res.data?.data ?? [] });
      })
      .catch((err) => {
        console.error("useJunctionChartData: fetch failed", err);
        setChartsData(EMPTY_CHARTS);
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { chartsData, loading, error, fetchChartData };
};

export default useJunctionChartData;
